import React, { useRef } from "react";
import "./recipe.css";
import { CardComponent } from "./card";
export const RecipeComponent = (props) => {
    const { recipe } = props;
    const ref = useRef();
    recipe.element = ref.current;
    return (React.createElement("div", { className: "recipe", ref: ref },
        React.createElement("span", { className: "recipeName" }, recipe.result.displayName),
        React.createElement("section", { className: "content" },
            React.createElement("div", { className: "dropzone left" },
                React.createElement("div", { className: "bgContainer" },
                    React.createElement("img", { src: recipe.leftCard.artUrl, className: "background" }),
                    React.createElement("span", { className: "dropTitle" }, recipe.leftCard.displayName)),
                recipe.leftCardCurrent && React.createElement(CardComponent, { card: recipe.leftCardCurrent })),
            React.createElement("span", { className: "plus" }, "+"),
            React.createElement("div", { className: "dropzone right" },
                React.createElement("div", { className: "bgContainer" },
                    React.createElement("img", { src: recipe.rightCard.artUrl, className: "background" }),
                    React.createElement("span", { className: "dropTitle" }, recipe.rightCard.displayName)),
                recipe.rightCardCurrent && React.createElement(CardComponent, { card: recipe.rightCardCurrent })),
            React.createElement("span", { className: "equals" }, "="),
            React.createElement("div", { className: "dropzone result" },
                React.createElement("div", { className: "bgContainer" },
                    React.createElement("img", { src: recipe.result.artUrl, className: "background" }),
                    React.createElement("span", { className: "dropTitle" }, recipe.result.displayName)),
                recipe.crafted && React.createElement(CardComponent, { card: recipe.crafted })))));
};
